import { useEffect } from "react";
import liff from "@line/liff";
import { initLiffOnce } from "../../context/LiffProfileContext"; // singleton เดิม

export default function LogoutPage() {
  useEffect(() => {
    const doLogout = async () => {
      try {
        // 1️⃣ Init ก่อนเสมอ — ใช้ singleton ไม่ init ซ้ำ
        await initLiffOnce();

        // 2️⃣ Logout LIFF session
        if (liff.isLoggedIn()) {
          liff.logout(); // จะ redirect ออกเองถ้าอยู่ใน LINE app
        }

        // 3️⃣ Clear storage หลัง logout (ไม่ใช้ localStorage.clear()
        //    เพราะลบ key อื่นที่ไม่เกี่ยวด้วย เช่น i18n, theme)
        localStorage.removeItem("authToken");
        localStorage.removeItem("userId");
        localStorage.removeItem("bigCardNumber");

        // 4️⃣ Clear cookies เฉพาะที่ app ใช้ (ถ้ามี)
        document.cookie.split(";").forEach((c) => {
          document.cookie = c
            .replace(/^ +/, "")
            .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
      } catch (e) {
        console.error("Logout error:", e);
        // แม้ error ก็ต้อง clear storage ให้ได้
        localStorage.removeItem("authToken");
        localStorage.removeItem("userId");
        localStorage.removeItem("bigCardNumber");
      } finally {
        // 5️⃣ Redirect — ไม่ใส่ timestamp query เพราะเสี่ยง liff.state loop
        window.location.replace("/login");
      }
    };

    doLogout();
  }, []);

  return <div>Logging out...</div>;
}